import * as bootstrap from 'bootstrap';
import '../scss/style.scss';

document.querySelectorAll('.dropdown-submenu > .dropdown-toggle').forEach(item => {
  item.addEventListener('click', e => {
    e.preventDefault();
    e.stopPropagation();

    const parentSubmenu = item.closest('.dropdown-submenu');
    const allSiblings = parentSubmenu.parentElement.querySelectorAll('.dropdown-submenu .dropdown-menu.show');

    allSiblings.forEach(menu => {
      if (menu !== item.nextElementSibling) {
        menu.classList.remove('show');
      }
    });

    const submenu = item.nextElementSibling;
    if (submenu && submenu.classList.contains('dropdown-menu')) {
      submenu.classList.toggle('show');
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const btn = document.getElementById('backToTop');
  if (!btn) return;

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const toggle = () => {
    if (window.scrollY > 300) btn.classList.add('show');
    else btn.classList.remove('show');
  };

  window.addEventListener('scroll', toggle, { passive: true });
  toggle();

  btn.addEventListener('click', (e) => {
    e.preventDefault();
    if (prefersReduced) window.scrollTo(0, 0);
    else window.scrollTo({ top: 0, behavior: 'smooth' });
  });

});

(function (global) {
  function animateOnScroll(selector, animation, options = {}) {
    const settings = { delay: 0, threshold: 0.1, once: true, ...options };
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const elements = document.querySelectorAll(selector);

    const reveal = (el, index) => {
      if (!prefersReduced) {
        el.style.animationDelay = `${index * settings.delay}s`;
        el.classList.add('animate__animated', `animate__${animation}`);
      } else {
        el.style.opacity = 1;
        el.style.transform = 'none';
      }
      if (settings.once) observer.unobserve(el);
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => entry.isIntersecting && reveal(entry.target, Array.from(elements).indexOf(entry.target)));
    }, { threshold: settings.threshold });

    elements.forEach(el => { el.style.opacity = 0; observer.observe(el); });
  }

  // expose globally
  global.animateOnScroll = animateOnScroll;
})(window);
